import axios from "axios";
import LayerSwapApiClient from "./apiClients/layerSwapApiClient";
export const InitializeAuthInstance = (baseURL) => {
    const instance = axios.create({
        baseURL: baseURL || "",
        headers: {
            "Content-Type": "application/json",
        },
    });
    instance.interceptors.request.use(async (config) => {
        const apiKey = LayerSwapApiClient.apiKey;
        if (apiKey) {
            config.headers["X-LS-APIKEY"] = apiKey;
        }
        else {
            throw new Error("Api key is not provided");
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    return instance;
};
export const InitializeUnauthInstance = (baseURL) => {
    const instance = axios.create({
        baseURL: baseURL || "",
        headers: {
            "Content-Type": "application/json",
        },
    });
    instance.interceptors.request.use(async (config) => {
        const apiKey = LayerSwapApiClient.apiKey;
        if (apiKey) {
            config.headers["X-LS-APIKEY"] = apiKey;
        }
        else {
            throw new Error("Api key is not provided");
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    return instance;
};
export default InitializeAuthInstance;
